export let memoizedHasTouchScreen: boolean | null = null;

export const setMemoizedTouchScreenState = (value: boolean | null) => {
    memoizedHasTouchScreen = value;
};
